const Genders = [
  { label: "Male", id: "MALE" },
  { label: "Female", id: "FEMALE" },
  { label: "Unknown", id: "NOT_KNOWN" },
];

export default Genders;
